export default "__VITE_ASSET__C6hAbkT7__"